export default __webpack_public_path__ + "static/media/forwardArrowImg.166caa8f.svg";